import { useTranslation } from '@exam-room/translations';
import { type PropsWithChildren } from 'react';

import { LoadingSpinner } from '../../../../../components';

import { EXAM_PREVIEW_LOADING_VARIANT_MAP } from './constants';
import { type ExamPreviewLoadingVariant } from './types';

interface ExamPreviewLoadingProps extends PropsWithChildren {
  variant: ExamPreviewLoadingVariant;
}

function ExamPreviewLoading(props: Readonly<ExamPreviewLoadingProps>) {
  const { variant } = props;

  const { t } = useTranslation();

  const { title, message, style } = EXAM_PREVIEW_LOADING_VARIANT_MAP[variant];

  return (
    <div className={style}>
      <LoadingSpinner variant='flat' className='h-20 w-20' />
      <div className='flex flex-col gap-2'>
        <p className='text-center text-2xl font-semibold'>{t(title)}</p>
        <p className='text-text-secondary text-center'>{t(message)}</p>
      </div>
    </div>
  );
}

export default ExamPreviewLoading;
